import BaseAPIClient from './base/BaseAPIClient';

export default class PlatformClient extends BaseAPIClient {
  async getFeatures({studentUserId, schoolId, counselorId}){ // :string[]
    const response = await this._get(
      'v2/platform/features', 
      {studentUserId, schoolId, counselorId});

    return response.names;
  }
  async setFeature({studentUserId, schoolId, counselorId}, name) { // :string[]
    const response = await this._post(
      'v2/platform/features', 
      {studentUserId, schoolId, counselorId, name});

    return response.names;
  }
  async deleteFeature({studentUserId, schoolId, counselorId}, name) { // :string[]
    const response = await this._delete(
      'v2/platform/features', 
      {studentUserId, schoolId, counselorId, name});

    return response.names;
  }
}
